import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import { toast } from '@gitbook/spine-react';

import { apiClient } from '../../state/api';

/**
 * Apply a site template to a site.
 * This function creates the spaces for the template and sets them as sections for the site.
 */
export async function applySiteTemplate(props: { organizationId: string; site: api.Site }) {
    const { organizationId, site } = props;

    await toast.catch(async () => {
        await apiClient.sites.applyTemplateToSite(organizationId, site.id);

        analytics.logEvent({
            type: 'templates_pick_template',
            template: 'builtin:ultimate-template',
            organization: organizationId,
            site: site.id,
        });
    }, 'An error occurred while applying the template.');
}
